import React, { FC } from 'react';
import { Box, useTheme } from '@mui/material';

const Logo: FC = () => {
  const theme = useTheme() as any;

  return (
    <Box
      sx={{
        width: 309.41,
        height: 105.01,
        '& .primary-color': {
          fill: theme.palette.logo?.primary,
          transition: `fill ${theme.tokens.animations.normal} ${theme.tokens.animations.easing}`,
        },
        '& .secondary-color': {
          fill: theme.palette.logo?.secondary,
          transition: `fill ${theme.tokens.animations.normal} ${theme.tokens.animations.easing}`,
        },
        '& .text-color': {
          fill: theme.palette.text.primary,
          transition: `fill ${theme.tokens.animations.normal} ${theme.tokens.animations.easing}`,
        },
      }}
    >
      <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 649.4 179.39">
        <g id="Layer_1" data-name="Layer 1">
          <g>
            <path className="secondary-color" d="M123.83,138c1.95-8.6,2.84-19.07.84-31.11-4.38-26.28-23-47.97-23-47.97-12.92-18.18-47.92-28.28-68.34-8.74-13.09,12.53-11.95,34.95,4.97,43.66,13.92,7.17,32.26-3.53,34.77-18.4-.69,9-4.07,25.26-19.23,28.48-11.36,2.42-23.92-.04-32.23-8.52-8.89-9.07-11.29-22.95-9.27-35.12,1.99-11.97,10.84-21.14,20.72-27.56,20.35-13.2,53.88-8.5,71.28,7.93,14.57,13.76,37.71,51.21,19.49,97.35Z"/>
            <path className="primary-color" d="M144.61,70.33C147.13,13.69,96.63,0,96.63,0c28.91,2.63,42.49,17.74,53.44,33.29,10.95,15.55,13.36,44.9,2.63,80.17-10.73,35.26-33.07,65.93-33.07,65.93l-31.54-20.81c2.61-24.14-12.77-44.82-12.99-45.12,23.14,10.07,23.95,35.48,23.95,35.48l16.43,11.17c2.25-4.39,6.05-11.94,8.36-22.11,18.22-46.14-4.92-83.58-19.49-97.35-17.4-16.43-50.93-21.14-71.28-7.93-9.88,6.42-18.73,15.58-20.72,27.56-2.02,12.17.38,26.05,9.27,35.12,8.32,8.49,20.87,10.94,32.23,8.52,15.17-3.22,18.54-19.48,19.23-28.48.33-1.94.38-3.96.13-6.01,6.91,54.84-35.92,51.79-56.21,35.63C-3.75,88.55-8.85,50.69,20.85,23.03,42.1,3.24,80.04,2.9,103.72,18.65c12.75,8.48,23.9,19.81,31.95,32.84,2.71,4.39,9.07,13.19,8.94,18.84Z"/>
            <path className="primary-color" d="M112.08,135.84l-.16-.55c.06.19.12.37.16.55Z"/>
            <path className="primary-color" d="M99.66,92.79c.38,1.03,12.37,34.05,12.42,43.05-.04-.18-.1-.36-.16-.55h0s-12.26-42.5-12.26-42.5Z"/>
            <path className="primary-color" d="M99.65,92.77c14.6,13.59,12.43,43.08,12.43,43.08-.05-9.01-12.05-42.02-12.42-43.05v-.02Z"/>
            <path className="secondary-color" d="M99.65,92.77v.02s12.27,42.49,12.27,42.49c-2.03-5.93-15.45-18.67-15.45-18.67l3.18-23.85Z"/>
          </g>
          <g>
            <path className="text-color" d="M285.68,134.82l-1.24-13.18c-5.77,10.16-15.8,14.97-27.75,14.97-25.55,0-41.9-18.27-41.9-48.36s16.35-48.62,43.27-48.62c18.54,0,34.48,10.16,38.88,29.53h-16.07c-3.3-10.72-12.09-16.62-23.22-16.62-17.03,0-27.2,13.6-27.2,35.71s10.3,35.45,27.61,35.45c12.77,0,23.08-7.69,24.04-25.55h-22.12v-11.95h36.81v48.63h-11.12Z"/>
            <path className="text-color" d="M339.24,88.25c0-29.94,17.03-48.62,44.92-48.62s44.78,18.68,44.78,48.62-17.17,48.36-44.78,48.36-44.92-18.41-44.92-48.36ZM413.28,88.25c0-22.12-10.85-35.71-29.12-35.71s-29.26,13.6-29.26,35.71,10.99,35.45,29.26,35.45,29.12-13.46,29.12-35.45Z"/>
            <path className="text-color" d="M525.78,113.8h-42.59l-7.97,21.02h-15.39l35.99-93.41h17.99l35.99,93.41h-16.07l-7.97-21.02ZM487.86,101.71h33.24l-13.87-36.4-2.75-9.07-2.75,9.07-13.87,36.4Z"/>
            <path className="text-color" d="M602.97,54.32h-31.18v-12.91h77.62v12.91h-31.04v80.5h-15.39V54.32Z"/>
          </g>
        </g>
      </svg>
    </Box>
  );
};

export default Logo;
